// @flow
import * as api from '../helpers/helpers.api';

export function addTextControlContactsApi(...contacts: Array<Object>): Promise<Response> {
    return api.httpPost('contacts', { contacts }, true);
}

export function getTextControlContactsApi(): Promise<Response> {
    return api.httpGet('contacts', true);
}

export function deleteTextControlContactsApi(...contactIds: Array<string>): Promise<Response> {
    return api.httpDelete('contacts', { contacts: contactIds }, true);
}

export function updateTextControlContactsApi(...contacts: Array<Object>): Promise<Response> {
    return api.httpPut('contacts', { contacts }, true);
}



// WEBPACK FOOTER //
// ./src/core/api/text-control/text-control.api.js